import React from 'react';
import _ from 'lodash';

import Grid from '../Grid';

class LocalGrid extends React.Component {
  state = {
    limit: 10,
    offset: 0,
  }

  componentWillMount() {
    const { data } = this.props;
    const { offset, limit } = this.state;
    
    this.setState({
      data: (data || []).slice(offset, offset + limit)
    });
  }

  render() {
    const { data, ...other } = this.props;
    return (<Grid
      data={{ data }}
      fetch={_.noop}
      {...other}
    />);
  }
}

export default LocalGrid;



// WEBPACK FOOTER //
// ./src/components/Common/LocalGrid/index.js